<script lang="ts">
import FicheProjetList from '@/generated/fiches/FicheProjetList.vue';
import { defineComponent } from "vue";
import {storePaie} from "@/generated/stores";
import {ListFilter} from "@/extend/classes/ListData.ts";

export default defineComponent({
    components: {},
    extends: FicheProjetList,
    methods: {
      isDisplayed(value: string): boolean {
        return true;
      }
    }
})

</script>
